<script lang="ts" setup>
defineProps<{
  currentValue: number;
  maxValue: number;
}>();
</script>

<template>
  <div class="text-input-counter">{{ currentValue }} / {{ maxValue }}</div>
</template>

<style scoped>
@import "TextInputCounter.css";
</style>
